"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  'template-a[desktop]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 100,
      'letterSpacing': 0,
      'lineHeightPx': 100,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -6034,
        'y': 726,
        'width': 1086,
        'height': 100
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 40,
      'letterSpacing': 0,
      'lineHeightPx': 48,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -6034,
        'y': 814,
        'width': 1086,
        'height': 48
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': 24,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -5941,
        'y': 877,
        'width': 900,
        'height': 48
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'icon-card': {
      'fontFamily': '',
      'fontWeight': 400,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': '',
      'absoluteBoundingBox': {
        'x': -6034,
        'y': 970,
        'width': 342,
        'height': 296
      },
      'children': [{
        'id': '788:39',
        'name': 'headline1',
        'type': 'TEXT',
        'blendMode': 'PASS_THROUGH',
        'absoluteBoundingBox': {
          'x': -6019,
          'y': 1065,
          'width': 312,
          'height': 36
        },
        'constraints': {
          'vertical': 'TOP',
          'horizontal': 'LEFT'
        },
        'fills': [{
          'blendMode': 'NORMAL',
          'type': 'SOLID',
          'color': {
            'r': 0.07450980693101883,
            'g': 0.12941177189350128,
            'b': 0.13333334028720856,
            'a': 1
          }
        }],
        'strokes': [],
        'strokeWeight': 1,
        'strokeAlign': 'OUTSIDE',
        'styles': {
          'fill': '8:6',
          'text': '388:234'
        },
        'effects': [],
        'characters': 'lorem ipsum dolor sit ',
        'style': {
          'fontFamily': 'Objektiv Mk2',
          'fontPostScriptName': 'ObjektivMk2-Bold',
          'fontWeight': 700,
          'textAutoResize': 'HEIGHT',
          'fontSize': 24,
          'textAlignHorizontal': 'CENTER',
          'textAlignVertical': 'TOP',
          'letterSpacing': 0,
          'lineHeightPx': 36,
          'lineHeightPercent': 128,
          'lineHeightPercentFontSize': 150,
          'lineHeightUnit': 'PIXELS'
        },
        'characterStyleOverrides': [],
        'styleOverrideTable': {}
      }, {
        'id': '788:40',
        'name': 'headline2',
        'type': 'TEXT',
        'blendMode': 'PASS_THROUGH',
        'absoluteBoundingBox': {
          'x': -6019,
          'y': 1111,
          'width': 312,
          'height': 84
        },
        'constraints': {
          'vertical': 'TOP',
          'horizontal': 'LEFT'
        },
        'fills': [{
          'blendMode': 'NORMAL',
          'type': 'SOLID',
          'color': {
            'r': 0.07450980693101883,
            'g': 0.12941177189350128,
            'b': 0.13333334028720856,
            'a': 1
          }
        }],
        'strokes': [],
        'strokeWeight': 1,
        'strokeAlign': 'OUTSIDE',
        'styles': {
          'fill': '8:6',
          'text': '40:2682'
        },
        'effects': [],
        'characters': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Enim urna urna quis pellentesque at penatibus sed. Dis elementum vel, ac non sed diam.',
        'style': {
          'fontFamily': 'Objektiv Mk2',
          'fontPostScriptName': 'ObjektivMk2-Light',
          'fontWeight': 300,
          'textAutoResize': 'HEIGHT',
          'fontSize': 14,
          'textAlignHorizontal': 'CENTER',
          'textAlignVertical': 'TOP',
          'letterSpacing': 0,
          'lineHeightPx': 21,
          'lineHeightPercent': 128,
          'lineHeightPercentFontSize': 150,
          'lineHeightUnit': 'PIXELS'
        },
        'characterStyleOverrides': [],
        'styleOverrideTable': {}
      }]
    }
  },
  'template-a[tablet]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 90,
      'letterSpacing': 0,
      'lineHeightPx': 90,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -4591,
        'y': 714,
        'width': 708,
        'height': 90
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 32,
      'letterSpacing': 0,
      'lineHeightPx': 40,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -4591,
        'y': 792,
        'width': 708,
        'height': 40
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': 24,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -4591,
        'y': 847,
        'width': 708,
        'height': 72
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'icon-card': {
      'fontFamily': '',
      'fontWeight': 400,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': '',
      'absoluteBoundingBox': {
        'x': -4591,
        'y': 964,
        'width': 216,
        'height': 377
      },
      'children': [{
        'id': '788:462',
        'name': 'headline1',
        'type': 'TEXT',
        'blendMode': 'PASS_THROUGH',
        'absoluteBoundingBox': {
          'x': -4576,
          'y': 1059,
          'width': 186,
          'height': 54
        },
        'constraints': {
          'vertical': 'TOP',
          'horizontal': 'LEFT'
        },
        'fills': [{
          'blendMode': 'NORMAL',
          'type': 'SOLID',
          'color': {
            'r': 0.07450980693101883,
            'g': 0.12941177189350128,
            'b': 0.13333334028720856,
            'a': 1
          }
        }],
        'strokes': [],
        'strokeWeight': 1,
        'strokeAlign': 'OUTSIDE',
        'styles': {
          'fill': '8:6',
          'text': '388:706'
        },
        'effects': [],
        'characters': 'lorem ipsum dolor sit amet',
        'style': {
          'fontFamily': 'Objektiv Mk2',
          'fontPostScriptName': 'ObjektivMk2-Bold',
          'fontWeight': 700,
          'textAutoResize': 'HEIGHT',
          'fontSize': 18,
          'textAlignHorizontal': 'CENTER',
          'textAlignVertical': 'TOP',
          'letterSpacing': 0,
          'lineHeightPx': 27,
          'lineHeightPercent': 128,
          'lineHeightPercentFontSize': 150,
          'lineHeightUnit': 'PIXELS'
        },
        'characterStyleOverrides': [],
        'styleOverrideTable': {}
      }, {
        'id': '788:463',
        'name': 'headline2',
        'type': 'TEXT',
        'blendMode': 'PASS_THROUGH',
        'absoluteBoundingBox': {
          'x': -4576,
          'y': 1123,
          'width': 186,
          'height': 147
        },
        'constraints': {
          'vertical': 'TOP',
          'horizontal': 'LEFT'
        },
        'fills': [{
          'blendMode': 'NORMAL',
          'type': 'SOLID',
          'color': {
            'r': 0.07450980693101883,
            'g': 0.12941177189350128,
            'b': 0.13333334028720856,
            'a': 1
          }
        }],
        'strokes': [],
        'strokeWeight': 1,
        'strokeAlign': 'OUTSIDE',
        'styles': {
          'fill': '8:6',
          'text': '40:2685'
        },
        'effects': [],
        'characters': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Enim urna urna quis pellentesque at penatibus sed. Dis elementum vel, ac non sed diam.',
        'style': {
          'fontFamily': 'Objektiv Mk2',
          'fontPostScriptName': 'ObjektivMk2-Light',
          'fontWeight': 300,
          'textAutoResize': 'HEIGHT',
          'fontSize': 14,
          'textAlignHorizontal': 'CENTER',
          'textAlignVertical': 'TOP',
          'letterSpacing': 0,
          'lineHeightPx': 21,
          'lineHeightPercent': 128,
          'lineHeightPercentFontSize': 150,
          'lineHeightUnit': 'PIXELS'
        },
        'characterStyleOverrides': [],
        'styleOverrideTable': {}
      }]
    }
  },
  'template-a[mobile]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 90,
      'letterSpacing': 0,
      'lineHeightPx': 90,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -3673,
        'y': 714,
        'width': 327,
        'height': 90
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 32,
      'letterSpacing': 0,
      'lineHeightPx': 40,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -3673,
        'y': 792,
        'width': 327,
        'height': 40
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': 24,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -3673,
        'y': 847,
        'width': 327,
        'height': 120
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'icon-card': {
      'fontFamily': '',
      'fontWeight': 400,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': '',
      'absoluteBoundingBox': {
        'x': -3679,
        'y': 997,
        'width': 327,
        'height': 287
      },
      'children': [{
        'id': '788:689',
        'name': 'headline1',
        'type': 'TEXT',
        'blendMode': 'PASS_THROUGH',
        'absoluteBoundingBox': {
          'x': -3664,
          'y': 1092,
          'width': 297,
          'height': 27
        },
        'constraints': {
          'vertical': 'TOP',
          'horizontal': 'LEFT'
        },
        'fills': [{
          'blendMode': 'NORMAL',
          'type': 'SOLID',
          'color': {
            'r': 0.07450980693101883,
            'g': 0.12941177189350128,
            'b': 0.13333334028720856,
            'a': 1
          }
        }],
        'strokes': [],
        'strokeWeight': 1,
        'strokeAlign': 'OUTSIDE',
        'styles': {
          'fill': '8:6',
          'text': '388:706'
        },
        'effects': [],
        'characters': 'lorem ipsum dolor sit amet',
        'style': {
          'fontFamily': 'Objektiv Mk2',
          'fontPostScriptName': 'ObjektivMk2-Bold',
          'fontWeight': 700,
          'textAutoResize': 'HEIGHT',
          'fontSize': 18,
          'textAlignHorizontal': 'CENTER',
          'textAlignVertical': 'TOP',
          'letterSpacing': 0,
          'lineHeightPx': 27,
          'lineHeightPercent': 128,
          'lineHeightPercentFontSize': 150,
          'lineHeightUnit': 'PIXELS'
        },
        'characterStyleOverrides': [],
        'styleOverrideTable': {}
      }, {
        'id': '788:690',
        'name': 'headline2',
        'type': 'TEXT',
        'blendMode': 'PASS_THROUGH',
        'absoluteBoundingBox': {
          'x': -3664,
          'y': 1129,
          'width': 297,
          'height': 84
        },
        'constraints': {
          'vertical': 'TOP',
          'horizontal': 'LEFT'
        },
        'fills': [{
          'blendMode': 'NORMAL',
          'type': 'SOLID',
          'color': {
            'r': 0.07450980693101883,
            'g': 0.12941177189350128,
            'b': 0.13333334028720856,
            'a': 1
          }
        }],
        'strokes': [],
        'strokeWeight': 1,
        'strokeAlign': 'OUTSIDE',
        'styles': {
          'fill': '8:6',
          'text': '40:2685'
        },
        'effects': [],
        'characters': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Enim urna urna quis pellentesque at penatibus sed. Dis elementum vel, ac non sed diam.',
        'style': {
          'fontFamily': 'Objektiv Mk2',
          'fontPostScriptName': 'ObjektivMk2-Light',
          'fontWeight': 300,
          'textAutoResize': 'HEIGHT',
          'fontSize': 14,
          'textAlignHorizontal': 'CENTER',
          'textAlignVertical': 'TOP',
          'letterSpacing': 0,
          'lineHeightPx': 21,
          'lineHeightPercent': 128,
          'lineHeightPercentFontSize': 150,
          'lineHeightUnit': 'PIXELS'
        },
        'characterStyleOverrides': [],
        'styleOverrideTable': {}
      }]
    }
  }
};
exports.default = _default;